import { Role } from '@guiker/permissions'

import { RentPaymentActions } from '../permissions'
import { RentPaymentRoleNames } from '../role-names'

export const PayerRole: Role = {
  name: RentPaymentRoleNames.PAYER,
  permissions: [{ action: RentPaymentActions.ViewRentPaymentsPlan }],
}
